import { render, staticRenderFns } from "./brigada-prevencion-editar.vue?vue&type=template&id=6c8a88a9&scoped=true&"
import script from "./brigada-prevencion-editar.vue?vue&type=script&lang=js&"
export * from "./brigada-prevencion-editar.vue?vue&type=script&lang=js&"
import style0 from "./brigada-prevencion-editar.vue?vue&type=style&index=0&id=6c8a88a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a88a9",
  null
  
)

export default component.exports